import { Badge, Box, Button, Flex, Hide, Link, Text, Tooltip, getPaletteColor } from 'pcln-design-system'
import { Copy as CopyIcon, Coupon as CouponIcon } from 'pcln-icons'
import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

const CouponClipboardBox = styled(Box)`
  &:focus {
    border: 1px solid ${getPaletteColor('primary.base')};
  }
`

const CouponCodeFlex = styled(Flex)`
  border: 2px dotted ${getPaletteColor('text.dark')};
`

const CouponText = styled(Flex)`
  white-space: nowrap;
`

const CouponClipboard = ({
  buttonText: linkText = 'Copy',
  coupon,
  mb = 4,
  redeemCopy,
  toolTipMessage = 'Copied - sign in and apply at checkout',
  handleClick,
  handleExternalClick,
  hideIconOnMobile = true,
  ...props
}) => {
  const [showToolTip, setShowToolTip] = useState(false)
  const ariaLabel = `Copy coupon code ${coupon}`

  const handleCouponClick = useCallback(() => {
    navigator.clipboard?.writeText(coupon)
    setShowToolTip(true)
    handleClick && handleClick()
    setTimeout(() => {
      setShowToolTip(false)
    }, 2000)
  }, [coupon, handleClick, setShowToolTip])

  const copyIcon = (
    <Flex alignItems='center'>
      <CopyIcon data-testid='copyIcon' ml={2} color='primary' />
    </Flex>
  )

  useEffect(() => {
    if (handleExternalClick) {
      handleExternalClick.current = handleCouponClick
    }
  }, [handleCouponClick, handleExternalClick])

  return (
    <CouponClipboardBox alignItems='flex-start' flexDirection='column' mb={mb} {...props}>
      {showToolTip && (
        <Tooltip color='text.light' top left>
          {toolTipMessage}
        </Tooltip>
      )}
      <Button aria-label={ariaLabel} color='transparent' p={0} onClick={handleCouponClick}>
        <Flex alignItems='center'>
          <CouponCodeFlex borderRadius='2xl' p='2px'>
            <Badge color='primary.dark'>
              <CouponText textStyle='captionBold'>Coupon Code: {coupon}</CouponText>
            </Badge>
          </CouponCodeFlex>
          {hideIconOnMobile ? (
            <Hide xs sm md>
              {copyIcon}
            </Hide>
          ) : (
            copyIcon
          )}
          {linkText && (
            <Link aria-label={ariaLabel} ml={2}>
              {linkText}
            </Link>
          )}
        </Flex>
      </Button>

      {redeemCopy ? (
        <Flex pl={1} mt={1}>
          <CouponIcon color='strike' size={20} />
          <Text fontWeight='bold' ml={1} fontSize={1} color='strike'>
            {redeemCopy}
          </Text>
        </Flex>
      ) : null}
    </CouponClipboardBox>
  )
}

export default CouponClipboard
